<!-- 悬浮 -->
<template>
<div class='cm_imgFloat_congtainer' v-if="boxIsShow">
  <i class="el-icon-close" @click="closeBox()"></i>
  <img src="@/assets/img/index_float.png" @click="toDetail()">
</div>
</template>

<script>

export default {
components: {},
props:["data"],
data() {
//这里存放数据
return {
boxIsShow:true,
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
closeBox(){
  this.boxIsShow =false
},
toDetail(){
   this.$router.push({path:'/list',query: {urlData:JSON.stringify(this.data)}})
}
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},

}
</script>
<style scoped>
.cm_imgFloat_congtainer{
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 50;
}

.cm_imgFloat_congtainer>img{
  width:270px;
  height: 135px;
  cursor: pointer;
}
.cm_imgFloat_congtainer>i{
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.cm_imgFloat_congtainer>i:hover{
  background: #4379D3;
  color: #fff;
}
</style>